export default defineNuxtPlugin((nuxtApp) => {
  function isInvalid(errors: Record<string, string[]>) {
    return Object.keys(errors).length > 0;
  }
  nuxtApp.provide('isInvalid', isInvalid);
});